import { Col, Row, Spin, Table } from "antd";
import Title from "atoms/Title";
import COLORS from "common/Colors";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { useReactToPrint } from "react-to-print";
import Button from "atoms/Button";
import { useSelector } from "react-redux";
import { getManagingOffice, getUserList, getUserInfo } from "redux/selectors";
import { find, sumBy } from "lodash";
import { Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import moment from "moment";
import { currencyAmount } from "utils/functions";
import currencyMasterData from "common/currencyRateMasterData.json";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { billingOffice } from "common/Constants";
import logo from "../../../assets/RSM Logo.svg";
import bdologo from "../../../assets/bdo logo.svg";

const StyledRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* border: 2px solid #000; */
  .my-1 {
    display: flex;
    word-wrap: break-word;
  }
  .graybg {
    background-color: #f6f6f6;
  }
  .label_Color {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: #000;
  }
  .label_value_Color {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #1f243b;
  }
  .employess_detail_values {
    /* border-bottom: 1px solid #ccc; */
  }
`;

const StyledTable = styled(Table)`
  .ant-table-cell {
    padding: 10px 14px;
  }
  .action-status {
    background-color: #f7f7f8;
  }
  .ant-table-tbody > tr > td,
  .ant-table-thead > tr > th {
    border: 1px solid #dbdbdb;
  }
`;

function FinancialSummary() {
  const { id } = useParams();

  const [profitLoss, setProfitLoss] = useState(0);
  const { getEngagementById, getBillingById, getTimeSheetByengagementId } =
    queryKeys;
  const { key, url } = getEngagementById(id);
  const userInfo = useSelector(getUserInfo);
  const userId = userInfo?.userid;
  const { data: engagementDataRes } = useFetch(key, url, {
    enabled: !!id,
  });
  const mainContentRef = useRef();
  const lastTableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const printComponentRef = React.useRef();
  const logoCacheRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  });

  const handlePrintWithDelay = () => {
    setLoading(true);
    setTimeout(() => {
      handlePrint();
      setLoading(false);
    }, 2000); // 2-second delay
  };
  const engagementData = engagementDataRes?.data;
  const history = useHistory();
  const cursorStyle = { cursor: "pointer" };
  const [budjetChargeout, setBudjetChargeout] = useState("");

  const manageoffice = useSelector((state) => getManagingOffice(state));
  const userList = useSelector((state) => getUserList(state));

  const { key: billingKey, url: billingUrl } = getBillingById(id);
  const { key: timesheetKey, url: timesheetUrl } =
    getTimeSheetByengagementId(id);

  const { data: billingList } = useFetch(billingKey, billingUrl, {
    enabled: !!id,
  });

  const { data: timeSheetList } = useFetch(timesheetKey, timesheetUrl, {
    enabled: !!id,
  });

  const { key: actualSummaryKey, url: actualSummaryUrl } =
    queryKeys.getActualSummaryToEngagementId(id);

  const { data: actualSummaryData } = useFetch(
    actualSummaryKey,
    actualSummaryUrl,
    {
      enabled: !!id,
    }
  );

  const actualSummaryTimeSheetData = useMemo(() => {
    return actualSummaryData?.response?.data ?? [];
  }, [actualSummaryData]);

  const billingData = useMemo(() => {
    return (
      billingList?.response?.items?.filter(
        (val) =>
          val?.statusname === "Approved by Partner" ||
          val?.statusname === "Approved by Finance"
      ) ?? []
    );
  }, [billingList]);
  const conversionRate = parseFloat(
    engagementData?.financial_resourcePlan?.conversion_rate
  );
  const billingDisbursement = sumBy(billingData, (item) => {
    return sumBy(item.claims, (claim) => parseFloat(claim.amount));
  });
  let finalamount = billingDisbursement * (conversionRate || 1);

  const timeSheetData = useMemo(() => {
    return timeSheetList?.response?.response ?? [];
  }, [timeSheetList]);

  const convertionRate = currencyMasterData.find(
    (currency) =>
      currency.TBD_DESC === engagementData?.financial_resourcePlan?.currency
  )?.TBD_ABBR;

  const disbursementClaims =
    sumBy(timeSheetData, (item) =>
      item?.timesheetDisbursement
        ? item?.timesheetDisbursement
        : item?.claimsDisbursement || 0
    ) * (parseFloat(convertionRate) || 1);

  const actualBillingAmount = sumBy(
    billingData,
    (item) =>
      (parseFloat(item?.amount) || 0) * (parseFloat(convertionRate) || 1)
  );

  useEffect(() => {
    // Calculate the total billing amount
    const totalBilling = actualBillingAmount;
    // Calculate the total timeSheet cost
    const totalActualChargeoutAmount = matched.reduce((total, item) => {
      const emp = employeeLists.find(
        (e) =>
          e.userId === item.userId && Number(item.resourceId) === e.resourceId
      );

      const user = userList?.find(
        (user) => user.userid?.toLowerCase() === item?.userId?.toLowerCase()
      );

      const rate = parseFloat(emp?.resourceExtRate ?? user?.chargeoutrate ?? 0);

      // Get total approved hours for this resourceId + userId
      const tsEntry = actualSummaryTimeSheetData.find(
        (ts) => ts.userId === item.userId
      );

      const approvedHours =
        tsEntry?.actualTimesheet
          ?.filter(
            (ts) =>
              ts.resourceId.toString() === item.resourceId.toString() &&
              ts.status === "approved"
          )
          ?.reduce((acc, ts) => acc + (parseFloat(ts.sum) || 0), 0) || 0;

      return total + approvedHours * rate;
    }, 0);

    const disbursementClaims =
      sumBy(timeSheetData, (item) =>
        item?.timesheetDisbursement
          ? item?.timesheetDisbursement
          : item?.claimsDisbursement || 0
      ) * (parseFloat(convertionRate) || 1);

    // Calculate the total subcontractor amount
    const totalSubcontractorAmount = sumBy(
      timeSheetData,
      (item) =>
        parseFloat(
          item?.timesheetSubcontract
            ? item?.timesheetSubcontract
            : item?.claimsSubcontract
        ) || 0
    );

    // Calculate the total Bill Disbursement amount
    const totalBillDisbursementAmount = billingDisbursement;

    // Calculate the profit loss
    // Actual Calculation New flow
    // Billing amounts + Bill Disbsustment (New row which is coming from Billing Claims ) - Chargeout (Timehsset) - Claims (Both Subcont + dissbuontm
    const profitLoss =
      totalBilling +
      totalBillDisbursementAmount -
      totalActualChargeoutAmount -
      (disbursementClaims + totalSubcontractorAmount);

    setProfitLoss(profitLoss);
  }, [billingData, timeSheetData, engagementData, actualBillingAmount]);

  useEffect(() => {
    let mergedList = (engagementData?.employeeList ?? [])?.map((employee) => {
      let user = employeeLists?.find(
        (user) =>
          user?.userId === employee?.userId &&
          Number(user.resourceId) === Number(employee.resourceId)
      );
      return {
        ...employee,
        chargeoutrate: user ? user?.resourceExtRate?.toString() : null,
      };
    });

    const budjetChargeout = (mergedList ?? [])

      ?.filter((item) => item.personDay !== undefined && !isNaN(item.personDay))
      ?.map((item) => {
        const chargeRate = parseFloat(item.chargeoutrate);
        return !isNaN(chargeRate) ? chargeRate * item.personDay * 8 : 0;
      })
      .reduce((acc, value) => acc + value, 0);

    setBudjetChargeout(budjetChargeout);
  }, [engagementData]);

  const budgetedProfit =
    parseFloat(
      String(engagementData?.financial_resourcePlan?.billingAmount || "0")?.replace(
        /,/g,
        ""
      )
    ) *
      parseFloat(
        (
          String(engagementData?.financial_resourcePlan?.conversion_rate) || "0"
        )?.replace(/,/g, "")
      ) -
    (parseInt(budjetChargeout) +
      parseInt(
        sumBy(
          (engagementData?.subcontractor ?? [])?.map((item) => ({
            ...item,
            amount: parseInt(item.amount, 10) || 0,
          })),
          "amount"
        )
      ));

  const Information = [
    {
      name: "Engagement Title",
      value: engagementData?.information?.jobTitle
        ? engagementData?.information?.jobTitle
        : "-",
    },
    {
      name: "Managing Office",
      value: engagementData?.client?.managingOffice,
    },
    {
      name: "Manager",
      value: find(userList, {
        userid: engagementData?.stakeHolder?.personIncharge,
      })?.fullname
        ? find(userList, {
            userid: engagementData?.stakeHolder?.personIncharge,
          })?.fullname
        : "-",
    },
    {
      name: "Partner",
      value: find(userList, { userid: engagementData?.stakeHolder?.partner })
        ?.fullname
        ? find(userList, { userid: engagementData?.stakeHolder?.partner })
            ?.fullname
        : "-",
    },
    {
      name: "Client",
      value: engagementData?.client?.clientName
        ? engagementData?.client?.clientName
        : "-",
    },
    {
      name: "Competency",
      value: engagementData?.client?.competency,
    },
    {
      name: "Plan Start Date",
      value: engagementData?.stakeHolder?.planStartDate
        ? engagementData?.stakeHolder?.planStartDate
        : "-",
    },
    {
      name: "Plan End Date",
      value: engagementData?.stakeHolder?.planEndDate
        ? engagementData?.stakeHolder?.planEndDate
        : "-",
    },
    {
      name: "Client FY Month",
      value: engagementData?.client?.clientFyMonth
        ? engagementData?.client?.clientFyMonth
        : "-",
    },
  ];

  const PlannedFinancial = [
    {
      name: "Planned Billing",
      value:
        currencyAmount(
          "$",
          parseFloat(
            String(engagementData?.financial_resourcePlan?.billingAmount)?.replace(
              /,/g,
              ""
            )
          ) *
            parseFloat(
              String(engagementData?.financial_resourcePlan?.conversion_rate)?.replace(
                /,/g,
                ""
              )
            )
        ) || currencyAmount("$", 0),
    },
    {
      name: "Planned Chargeout",
      value: currencyAmount("$", budjetChargeout) ?? currencyAmount("$", 0),
    },
    {
      name: "Subcontract (Claims)",
      value:
        currencyAmount(
          "$",
          sumBy(
            (engagementData?.subcontractor ?? [])?.map((item) => ({
              ...item,
              amount: parseInt(item.amount, 10) || 0,
            })),
            "amount"
          )
        ) ?? currencyAmount("$", 0),
    },
    {
      name: "Profit",
      value: currencyAmount("$", budgetedProfit) ?? currencyAmount("$", 0),
    },
    {
      name: "PFA USD",
      value:
        budgetedProfit < 0
          ? currencyAmount("$", Math.abs(budgetedProfit))
          : currencyAmount("$", 0),
    },
  ];

  const employeeLists =
    Array.from(
      new Map(
        engagementData?.employeeList
          ?.filter((item) => item?.userId !== null)
          ?.map((item) => [item.resourceId, item])
      ).values()
    ) || [];
  const matched = [];

  actualSummaryTimeSheetData.forEach((ts) => {
    ts.actualTimesheet
      .filter((entry) => entry.status === "approved")
      .forEach((entry) => {
        const emp = employeeLists.find(
          (e) =>
            ts.userId === e.userId && Number(entry.resourceId) === e.resourceId
        );

        const alreadyMatched = matched.find(
          (m) => m.userId === ts.userId && m.resourceId === entry.resourceId
        );

        if (emp && !alreadyMatched) {
          matched.push({
            userId: ts.userId,
            resourceId: entry.resourceId,
            approvedHours: entry.sum,
          });
        }
      });
  });

  const AcutalFinancial = [
    {
      name: "Actual Billing",
      value: currencyAmount("$", actualBillingAmount) ?? currencyAmount("$", 0),
    },
    {
      name: "Billing Disbursement",
      value: currencyAmount("$", finalamount) ?? currencyAmount("$", 0),
    },
    {
      name: "Chargeout",
      value:
        currencyAmount(
          "$",
          matched.reduce((total, item) => {
            const emp = employeeLists.find(
              (e) =>
                e.userId === item.userId &&
                Number(item.resourceId) === e.resourceId
            );

            const user = userList?.find(
              (user) =>
                user.userid?.toLowerCase() === item?.userId?.toLowerCase()
            );

            const rate = parseFloat(
              emp?.resourceExtRate ?? user?.chargeoutrate ?? 0
            );

            // Get total approved hours for this resourceId + userId
            const tsEntry = actualSummaryTimeSheetData.find(
              (ts) => ts.userId === item.userId
            );

            const approvedHours =
              tsEntry?.actualTimesheet
                ?.filter(
                  (ts) =>
                    ts.resourceId.toString() === item.resourceId.toString() &&
                    ts.status === "approved"
                )
                ?.reduce((acc, ts) => acc + (parseFloat(ts.sum) || 0), 0) || 0;

            return total + approvedHours * rate;
          }, 0)
        ) || currencyAmount("$", 0),
    },
    {
      name: "Disbursement (Claims)",
      value:
        timeSheetData?.length > 0
          ? currencyAmount("$", disbursementClaims)
          : currencyAmount("$", 0),
    },
    {
      name: "Subcontractor (Disbursement)",
      value:
        currencyAmount(
          "$",
          sumBy(timeSheetData, (item) =>
            item?.timesheetSubcontract
              ? item?.timesheetSubcontract
              : item?.claimsSubcontract || 0
          )
        ) ?? currencyAmount("$", 0),
    },
    {
      name: "Profit/Loss",
      value: profitLoss
        ? currencyAmount("$", profitLoss)
        : currencyAmount("$", 0),
    },
  ];

  const Timesheet = [
    {
      name: "Planned Manhours",
      value:
        sumBy(engagementData?.employeeList, (employee) =>
          parseFloat(employee?.personDay || 0)
        ) * 8 ?? 0,
    },
    {
      name: "Actual Manhours",
      value: actualSummaryTimeSheetData.reduce((total, entry) => {
        const userHours =
          entry.actualTimesheet
            ?.filter((ts) => ts.status === "approved")
            ?.reduce((sum, ts) => sum + (parseFloat(ts.sum) || 0), 0) || 0;

        return total + userHours;
      }, 0),
    },

    {
      name: "Variance",
      value: (
        actualSummaryTimeSheetData.reduce((total, entry) => {
          const userHours =
            entry.actualTimesheet
              ?.filter((ts) => ts.status === "approved")
              ?.reduce((sum, ts) => sum + (parseFloat(ts.sum) || 0), 0) || 0;

          return total + userHours;
        }, 0) -
        (sumBy(
          engagementData?.employeeList || [],
          (employee) => parseFloat(employee?.personDay) || 0
        ) * 8 || 0)
      ).toFixed(2),
    },
  ];

  const columns = [
    {
      title: "S/N",
      dataIndex: "id",
      key: "id",
      render: (_, record, index) => index + 1,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Role",
      dataIndex: "projectRole",
      key: "projectRole",
    },
    {
      title: "Planned Manhours",
      dataIndex: "personDay",
      key: "personDay",
      align: "right",
      render: (val) => {
        if (!val) return 0;

        return parseFloat(val) * 8;
      },
    },
    {
      title: "Actual Manhours",
      dataIndex: "acutalmanhours",
      key: "acutalmanhours",
      align: "right",
      render: (val, record) => {
        let totalHours = 0;

        actualSummaryTimeSheetData.forEach((entry) => {
          if (entry.userId === record.userId) {
            const filtered = entry.actualTimesheet.filter(
              (timesheet) =>
                timesheet.resourceId.toString() ===
                  record.resourceId.toString() &&
                timesheet.status === "approved"
            );

            totalHours += filtered.reduce(
              (sum, val) => sum + (parseFloat(val.sum) || 0),
              0
            );
          }
        });

        return totalHours;
      },
    },
    {
      title: "Rate (USD)",
      dataIndex: "resourceExtRate",
      key: "resourceExtRate",
      align: "right",
      render: (val, record) => {
        const user = userList?.find((user) => {
          return user.userid?.toLowerCase() === record?.userId?.toLowerCase();
        });
        return `$${record?.resourceExtRate}` ?? "$0";
      },
    },
    {
      title: "Planned Chargeout Amount (USD)",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (val, record) => {
        const user = userList?.find((user) => {
          return user.userid?.toLowerCase() === record?.userId?.toLowerCase();
        });
        return (
          currencyAmount(
            "$",
            parseFloat(record?.resourceExtRate ?? 0) *
              parseFloat(record?.personDay ?? 0) *
              8
          ) ?? currencyAmount("$", val)
        );
      },
    },
    {
      title: "Actual total Chargeout Amount (USD)",
      dataIndex: "",
      key: "",
      align: "right",
      render: (val, record) => {
        let acutalmanhours = 0;

        actualSummaryTimeSheetData.forEach((entry) => {
          if (entry.userId === record.userId) {
            const filtered = entry.actualTimesheet.filter(
              (timesheet) =>
                timesheet.resourceId.toString() ===
                  record.resourceId.toString() &&
                timesheet.status === "approved"
            );

            acutalmanhours += filtered.reduce(
              (sum, val) => sum + (parseFloat(val.sum) || 0),
              0
            );
          }
        });

        const user = userList?.find((user) => {
          return user.userId?.toLowerCase() === record?.userId?.toLowerCase();
        });
        return (
          currencyAmount(
            "$",
            parseFloat(record?.resourceExtRate ?? 0) * acutalmanhours
          ) ?? currencyAmount("$", 0)
        );
      },
    },
    {
      title: "Claim (USD)",
      dataIndex: "claims",
      key: "claims",
      align: "right",
      render: (_, record) => {
        const foundItem =
          timeSheetData?.find(
            (item) =>
              Array.isArray(item?.claims) &&
              item?.claims?.some(
                (claim) =>
                  claim?.resourceId === String(record?.resourceId) &&
                  item?.employeeId === record?.userId
              )
          ) || [];

        const totalClaims = foundItem?.claims
          ?.filter((claim) => claim?.resourceId === String(record?.resourceId))
          ?.reduce((sum, claim) => {
            const amount = parseFloat(claim?.amount) || 0;
            return (
              sum +
              (claim?.type === "Subcontract"
                ? amount
                : amount * (parseFloat(convertionRate) || 1))
            );
          }, 0);

        return totalClaims ? `${currencyAmount("$", totalClaims)}` : "-";
      },
    },
  ];

  const breadStyle = { color: "#636980", cursor: "pointer" };
  const breadcrumbs = [
    <label key="2" style={breadStyle} onClick={() => history.goBack()}>
      {engagementData?.information?.jobTitle}
    </label>,
    <Typography key="3" color="text.primary">
      Financial Summary
    </Typography>,
  ];

  const [isPrintMode, setIsPrintMode] = useState(false);

  const svgToPngDataUrl = (svgUrl, width = 100, height = 40) => {
    return new Promise((resolve, reject) => {
      const img = new window.Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = svgUrl;
    });
  };

   const generatePdf = async () => {
    if (!mainContentRef.current || !lastTableRef.current) return;
    setIsPrintMode(true);
    setLoadingPdf(true);

    try {
      document.body.style.zoom = "1";

      const pdf = new jsPDF("p", "pt", "a4");
      const margin = 10;
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const headerHeight = 60;

      const imgWidth = pdfWidth - margin * 2;
      const pageContentHeight = pdfHeight - margin * 2 - headerHeight;

      const logoWidth = 100;
      const logoHeight = 40;

      if (!logoCacheRef.current) {
        logoCacheRef.current = await svgToPngDataUrl(bdologo, 100, 40);
      }
      const logoPngDataUrl = logoCacheRef.current;

      const printedBy = `Printed By: ${userInfo.userid}`;
      const printedDate = `${moment().format(
        "dddd, DD MMMM YYYY"
      )} - ${moment().format("HH:mm:ss")}`;

      const addHeader = () => {
        const centerX = pdfWidth / 2;
        pdf.addImage(logoPngDataUrl, "JPEG", margin, margin, logoWidth, logoHeight);
        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text("BDO East Africa", centerX, margin + 20, { align: "center" });
        pdf.setFontSize(12);
        pdf.setFont("helvetica", "normal");
        pdf.text(
          `Country: ${engagementData?.client?.managingOffice || "-"}`,
          centerX,
          margin + 40,
          { align: "center" }
        );
      };

      const addFooter = () => {
        const footerY = pdfHeight - margin + 10;
        pdf.setFontSize(10);
        pdf.text(printedBy, margin, footerY);
        pdf.text(printedDate, pdfWidth - margin, footerY, { align: "right" });
      };

      // ================= MAIN CONTENT =================
      const canvasMain = await html2canvas(mainContentRef.current, {
        scale: 1.5,
        useCORS: true,
      });

      const imgMainHeight = (canvasMain.height * imgWidth) / canvasMain.width;
      const imgMainData = canvasMain.toDataURL("image/jpeg", 0.9);

      let mainHeightLeft = imgMainHeight;
      let mainPositionY = margin + headerHeight;

      addHeader();
      pdf.addImage(
        imgMainData,
        "JPEG",
        margin,
        mainPositionY,
        imgWidth,
        imgMainHeight,
      );
      addFooter();

      mainHeightLeft -= pageContentHeight;

      while (mainHeightLeft > 0) {
        pdf.addPage();
        addHeader();

        pdf.addImage(
          imgMainData,
          "JPEG",
          margin,
          margin + headerHeight - (imgMainHeight - mainHeightLeft),
          imgWidth,
          imgMainHeight,
        );

        addFooter();
        mainHeightLeft -= pageContentHeight;
      }

      // ================= LAST TABLE =================
      pdf.addPage();
      addHeader();

      const canvasLast = await html2canvas(lastTableRef.current, {
        scale: 1.5,
        useCORS: true,
      });

      const imgLastWidth = imgWidth;
      const imgLastHeight =
        (canvasLast.height * imgLastWidth) / canvasLast.width;
      const imgLastData = canvasLast.toDataURL("image/jpeg", 0.9);

      let lastHeightLeft = imgLastHeight;

      pdf.addImage(
        imgLastData,
        "JPEG",
        margin,
        margin + headerHeight,
        imgLastWidth,
        imgLastHeight,
      );
      addFooter();

      lastHeightLeft -= pageContentHeight;

      while (lastHeightLeft > 0) {
        pdf.addPage();
        addHeader();

        pdf.addImage(
          imgLastData,
          "JPEG",
          margin,
          margin + headerHeight - (imgLastHeight - lastHeightLeft),
          imgLastWidth,
          imgLastHeight,
        );

        addFooter();
        lastHeightLeft -= pageContentHeight;
      }

      pdf.save("Financial Summary.pdf");
    } catch (err) {
      console.error("PDF generation failed:", err);
    } finally {
      document.body.style.zoom = "1";
      setLoadingPdf(false);
      setIsPrintMode(false);
    }
  };

  // Get the billing office ID from engagement data
  const billingOfficeId =
    engagementData?.financial_resourcePlan?.billingOffice ||
    engagementData?.billing_office ||
    null;

  // Map the ID to the name using billingOffice master data
  const billingEntity =
    billingOffice.find((office) => office.id === Number(billingOfficeId))
      ?.name || "-";

  return (
    <div>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>

      <div className="text-end">
        <Button
          type="primary"
          className="ms-0"
          loading={loadingPdf}
          onClick={generatePdf}
        >
          Print
        </Button>
      </div>
      <Spin spinning={loadingPdf} size="large">
        <div ref={mainContentRef} className="px-1">
          {/* {isPrintMode && <img src={userlogo} alt="BDO Logo" />} */}
          <h6>Information</h6>
          <StyledTable
            showHeader={false}
            columns={[
              {
                title: "Information",
                dataIndex: "name",
                key: "name",
                width: "30%",
                className: "action-status",
              },
              {
                title: "",
                dataIndex: "value",
                key: "value",
                width: "70%",
              },
            ]}
            dataSource={Information}
            pagination={false}
          />
          <br />
          <h6>Financial (USD)</h6>
          <h6>Planned:</h6>
          <StyledTable
            showHeader={false}
            columns={[
              {
                title: "",
                dataIndex: "name",
                key: "name",
                width: "30%",
                className: "action-status",
              },
              {
                title: "",
                dataIndex: "value",
                key: "value",
                width: "70%",
              },
            ]}
            dataSource={PlannedFinancial}
            pagination={false}
          />
          <br />
          <h6>Actual:</h6>
          <StyledTable
            showHeader={false}
            columns={[
              {
                title: "",
                dataIndex: "name",
                key: "name",
                width: "30%",
                className: "action-status",
              },
              {
                title: "",
                dataIndex: "value",
                key: "value",
                width: "70%",
              },
            ]}
            dataSource={AcutalFinancial}
            pagination={false}
          />
          <br />
          <h6>Timesheet</h6>
          <StyledTable
            showHeader={false}
            columns={[
              {
                title: "",
                dataIndex: "name",
                key: "name",
                width: "30%",
                className: "action-status",
              },
              {
                title: "",
                dataIndex: "value",
                key: "value",
                width: "70%",
              },
            ]}
            dataSource={Timesheet}
            pagination={false}
          />
          <br />
        </div>
        <div ref={lastTableRef} className="px-1">
          <StyledTable
            columns={columns}
            pagination={false}
            dataSource={
              Array.from(
                new Map(
                  engagementData?.employeeList
                    ?.filter((item) => item?.userId !== null)
                    ?.map((item) => [item.resourceId, item])
                ).values()
              ) || []
            }
            summary={(pageData) => {
              let totalPlannedHours = 0;
              let totalActualHours = 0;
              let totalPlannedAmount = 0;
              let totalActualAmount = 0;
              let totalClaims = 0;
              let totalRate = 0;

              pageData.forEach((record) => {
                const plannedHours = parseFloat(record?.personDay || 0) * 8;
                totalPlannedHours += plannedHours;

                let actualHours = 0;

                actualSummaryTimeSheetData.forEach((entry) => {
                  if (entry.userId === record.userId) {
                    const approvedEntries = entry.actualTimesheet.filter(
                      (ts) =>
                        ts.resourceId.toString() ===
                          record.resourceId.toString() &&
                        ts.status === "approved"
                    );

                    actualHours += approvedEntries.reduce(
                      (sum, ts) => sum + (parseFloat(ts.sum) || 0),
                      0
                    );
                  }
                });

                totalActualHours += actualHours;

                const rate = parseFloat(record?.resourceExtRate || 0);
                totalRate += rate;

                totalPlannedAmount += rate * plannedHours;
                totalActualAmount += rate * actualHours;

                // const foundItem = timeSheetData?.find(
                //   (item) => item?.employeeId === record?.userId
                // );
                const foundItem =
                  timeSheetData?.find(
                    (item) =>
                      Array.isArray(item?.claims) &&
                      item?.claims?.some(
                        (claim) =>
                          claim?.resourceId === String(record?.resourceId) &&
                          item?.employeeId === record?.userId
                      )
                  ) || [];

                const claimsAmount =
                  foundItem?.claims
                    ?.filter(
                      (claim) =>
                        claim?.resourceId?.toString() ===
                        record?.resourceId?.toString()
                    )
                    ?.reduce(
                      (sum, claim) =>
                        sum +
                        (claim?.type === "Subcontract"
                          ? parseFloat(claim?.amount)
                          : parseFloat(claim?.amount) *
                              (parseFloat(convertionRate) || 1) || 0),
                      0
                    ) || 0;

                totalClaims += claimsAmount;
              });

              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={3}>
                    <b>Total</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} align="right">
                    <b>{totalPlannedHours}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} align="right">
                    <b>{totalActualHours}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5} align="right"></Table.Summary.Cell>
                  <Table.Summary.Cell index={6} align="right">
                    <b>{currencyAmount("$", totalPlannedAmount)}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={7} align="right">
                    <b>{currencyAmount("$", totalActualAmount)}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={8} align="right">
                    <b>{currencyAmount("$", totalClaims)}</b>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />
        </div>
      </Spin>
    </div>
  );
}

export default FinancialSummary;
